import React, {useEffect} from 'react';
import CKEditors from "react-ckeditor-component";
import {Card,CardBody,CardHeader, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { MDBDataTableV5 } from 'mdbreact';

import '../../assets/scss/app-styles/qr-modal.scss'

const CallingNumberModal = (props) => {

    useEffect(() => {  
        console.log("availableCallingNumbers: ", props.availableCallingNumbers)
    }, []);
    
    return(
        <>
            <Modal isOpen={props.show} toggle={props.toggleHandler} size="lg">
                <ModalHeader toggle={props.toggleHandler}>
                    CallID Numbers For {props.selectedUser}
                </ModalHeader>
                <ModalBody className='callIdModal'>
                    <Card className="mb-3">
                        <CardHeader>
                            <h5>Choose Number</h5>
                        </CardHeader>
                        <CardBody>
                            <div className="search-container">
                                <i className="fa fa-phone type-ahead-search-icon" />
                                <input
                                    type="text"
                                    className="form-control search-domains"
                                    style={{ paddingLeft: '35px' }}
                                    placeholder="Enter a Calling Number..."
                                    value={props.selectedCallingPhoneNumber}
                                    onChange={props.CallingNumberChangeHandler}
                                />
                                <button 
                                    className="btn btn-primary add-btn" 
                                    type="button" 
                                    onClick={() => {
                                        props.saveCallingNumberHandler();
                                    }}
                                >
                                    Add
                                </button>
                            </div>
                        </CardBody>
                    </Card>

                    <Card>
                        <CardHeader>
                            <h5>Assigned Numbers</h5>
                        </CardHeader>
                        <CardBody className="p-0">
                            <MDBDataTableV5 
                                hover 
                                entriesOptions={[10, 25, 50, 100]} 
                                entries={10}
                                pagesAmount={4} 
                                data={props.assignedCallingNumbers} 
                                searchTop  
                                searchBottom={false}
                            />
                        </CardBody>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={props.toggleHandler}>
                        Done
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default CallingNumberModal;
